module.exports = __webpack_public_path__ + "static/img/3825_phase_function_Paper_Points.304ecef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3825_phase_function_Paper_Points.png
// module id = pikY
// module chunks = 0